import { uploadLivestreamRecordBlob } from './livestreamChunkUpload';

/**
 * Upload bản ghi chunk ngầm (không toast / không đổi statusMessage).
 * Đổi route trong SPA không hủy (Promise chạy độc lập).
 */
export function startBackgroundLivestreamRecordUpload({
  file,
  scheduleId,
  onProgress,
  onComplete,
  onError
}) {
  uploadLivestreamRecordBlob(file, scheduleId, { onProgress })
    .then(() => {
      if (onComplete) onComplete();
    })
    .catch((err) => {
      if (onError) onError(err);
    });
}
